import useStore from "../store"
import rollbarConfig from "../configs/rollbarConfig"
import Rollbar from "rollbar"
import { requestInterceptorRollbarLoggingEnabled } from "./featureFlags"

export default function requestInterceptor() {
  const logoutUser = useStore((state) => state.logoutUser)
  const user = useStore((state) => state.user)
  const rollbar = new Rollbar(rollbarConfig(user))
  const dfpApiUrl = import.meta.env['VITE_API_HOST']

  const { fetch: originalFetch } = window;
  window.fetch = async (...args) => {
    let [resource, config] = args

    let response = await originalFetch(resource, config)

    if (response.status == 401 && response.url.includes(dfpApiUrl)) {
      logoutUser()
      if (requestInterceptorRollbarLoggingEnabled) {
        rollbar.error("User logged out due to 401 error", config)
      }
    }

    return response
  }
}